import httpRequest from "./index";
import type { ProductConsignmentVo } from "@zhihaoscm/entity";

/**
 * 根据id获取寄售商品详情
 */
export const getProductConsignmentById = async (id: string): Promise<ProductConsignmentVo> => {
    const { data } = await httpRequest.get(`/product-consignment/vo/${id}`);
    return data;
};
